<template>
  <v-data-table
    :headers="headers"
    :items="vessels"
    :search="search"
    sort-by="v_name"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Vessels</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">New</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    v-for="header in headers"
                    :key="header.value"
                  >
                    <v-text-field
                      v-if="
                        header.value != 'action' &&
                          header.type != 'select' &&
                          header.type != 'select_line'
                      "
                      v-model="editedItem[header.value]"
                      :label="header.text"
                    ></v-text-field>
                    <v-autocomplete
                      v-if="header.type === 'select'"
                      :items="countries"
                      v-model="editedItem[header.id]"
                      item-text="country_name"
                      item-value="country_id"
                      :label="header.text"
                      auto-select-first
                      no-data-text="Country Not Listed"
                    ></v-autocomplete>
                    <v-autocomplete
                      v-if="header.type === 'select_line'"
                      :items="lines"
                      v-model="editedItem[header.id]"
                      item-text="s_line_name"
                      item-value="s_line_id"
                      :label="header.text"
                      auto-select-first
                      no-data-text="Shipping Line Not Added"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mdi mdi-border-color"
        @click="editItem(item)"
      ></v-icon>
      <!--<v-icon small class="mdi mdi-delete" @click="deleteItem(item)"></v-icon>-->
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "VesselsDataTable",
  data: () => ({
    dialog: false,
    show: false,
    search: "",
    headers: [
      {
        text: "Vessel Name",
        align: "left",
        sortable: false,
        value: "vessel_name"
      },
      {
        text: "Shipping Line",
        value: "sline_name",
        type: "select_line",
        id: "sline_id"
      },
      { text: "Flag", value: "flag", type: "select", id: "vessel_flag" },
      { text: "Gross Tonage", value: "vessel_gt" },
      { text: "Net Tonage", value: "vessel_nt" },
      { text: "Serial no", value: "serial_no" },
      { text: "Actions", value: "action", sortable: false }
    ],
    countries: [],
    lines: [],
    vessels: [],
    editedIndex: -1,
    editedItem: {
      vessel_name: "",
      sline_name: "",
      vessel_flag: "",
      vessel_gt: 0,
      vessel_nt: 0,
      serial_no: ""
    },
    defaultItem: {
      vessel_name: "",
      sline_name: "",
      vessel_flag: "",
      vessel_gt: 0,
      vessel_nt: 0,
      serial_no: ""
    }
  }),

  computed: {
    //...mapGetters('vessels', ['allVessels']),
    formTitle() {
      return this.editedIndex === -1 ? "New Vessel" : "Edit Vessel";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();

      if (val)
        this.$store.dispatch("countries/fetchCountries").then(res => {
          this.countries = res;
        });
      this.$store.dispatch("shipping_lines/fetchLines").then(res => {
        this.lines = res;
      });
    }
  },

  mounted() {
    this.$store.dispatch("vessels/fetchVessels").then(res => {
      this.vessels = res;
    });
  },

  methods: {
    ...mapMutations("vessels", ["setVessels"]),
    ...mapActions("vessels", ["fetchVessels"]),
    initialize() {
      this.$store.dispatch("vessels/fetchVessels").then(res => {
        this.vessels = res;
      });
    },

    editItem(item) {
      this.editedIndex = this.vessels.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.vessels.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.$store.dispatch("vessels/deleteVessel", item).then(res => {
          if (res.success) {
            this.initialize();
            this.$noty.success(res.success);
          } else this.$noty.warning(res.error);
          return;
        });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        //Object.assign(this.vessels[this.editedIndex], this.editedItem)
        this.$store
          .dispatch("vessels/updateVessel", this.editedItem)
          .then(res => {
            if (res.success) {
              this.initialize();
              this.$noty.success(res.success);
            } else this.$noty.warning(res.error);
            return;
          });
      } else {
        this.$store
          .dispatch("vessels/saveVessel", this.editedItem)
          .then(res => {
            if (res.success) {
              this.initialize();
              this.$noty.success(res.success);
            } else this.$noty.warning(res.error);
            return;
          });
      }
      this.close();
    }
  }
};
</script>
